import { h } from 'preact';

const ChevronLeft = (props) => {
	return (
		<svg width="13" height="25" viewBox="0 0 13 25" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path d="M0.704262 1.78002C0.431262 1.48752 0.431262 1.01202 0.704262 0.719522C0.978762 0.427023 1.42126 0.427023 1.69576 0.719522L12.2948 11.968C12.5678 12.262 12.5678 12.7375 12.2948 13.03L1.69576 24.28C1.55926 24.427 1.37926 24.499 1.20076 24.499C1.02076 24.499 0.842262 24.427 0.704262 24.28C0.431262 23.9875 0.431262 23.512 0.704262 23.218L10.8203 12.499L0.704262 1.78002Z" />
		</svg>
	);
};

export default ChevronLeft;